import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon, XCircleIcon } from 'lucide-react';
const forYou = ["You're a high-achiever who feels night-time is the only time you have for yourself.", 'You wake up feeling groggy and resentful, no matter how much you try to fix your routine.', "You know late-night scrolling is hurting you, but traditional advice hasn't worked."];
const notForYou = ['Those seeking a clinical cure for severe medical insomnia.', 'Anyone not willing to spend 7 minutes transitioning from screen to sleep mode.'];
export function ForYouSection() {
  return <section className="py-24 px-4 sm:px-6 lg:px-8 relative" data-id="element-28">
      <div className="max-w-6xl mx-auto" data-id="element-29">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-8" data-id="element-30">
          {/* For You */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-navy-800/50 border border-navy-700 rounded-3xl p-8 md:p-10" data-id="element-31">
            <h3 className="font-heading text-2xl md:text-3xl font-bold text-white mb-8 flex items-center" data-id="element-32">
              <span className="bg-green-500/20 text-green-400 px-4 py-1 rounded-full text-sm mr-4 uppercase tracking-wider" data-id="element-33">
                Yes
              </span>
              This Is For You If:
            </h3>
            <ul className="space-y-6" data-id="element-34">
              {forYou.map((item, i) => <li key={i} className="flex items-start space-x-4" data-id="element-35">
                  <CheckCircle2Icon className="w-6 h-6 text-green-500 flex-shrink-0 mt-0.5" data-id="element-36" />
                  <span className="text-slate-300 text-lg leading-relaxed" data-id="element-37">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>

          {/* Not For You */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-navy-900 border border-navy-800 rounded-3xl p-8 md:p-10 opacity-80" data-id="element-38">
            <h3 className="font-heading text-2xl md:text-3xl font-bold text-slate-400 mb-8 flex items-center" data-id="element-39">
              <span className="bg-red-500/10 text-red-400 px-4 py-1 rounded-full text-sm mr-4 uppercase tracking-wider" data-id="element-40">
                No
              </span>
              This Is NOT For:
            </h3>
            <ul className="space-y-6" data-id="element-41">
              {notForYou.map((item, i) => <li key={i} className="flex items-start space-x-4" data-id="element-42">
                  <XCircleIcon className="w-6 h-6 text-red-400/70 flex-shrink-0 mt-0.5" data-id="element-43" />
                  <span className="text-slate-400 text-lg leading-relaxed" data-id="element-44">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}